
import {
	type ValidationResults,
	type ManifestStore,
} from '@contentauth/c2pa-web';

export const SUPPORTED_TAG_TYPES = ['audio', 'video', 'contentVideo'];
export type SegmentType = 'video' | 'audio' | 'contentVideo';

export interface ClaimGeneratorDisplayInfo {
	label: string;
	version: string;
}

export const C2PA_VERIFIED_ICON = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAADrklEQVR4Aa1VXSjkURQ/Mwb5NiHCrpHysCShJQ+LtkSofdqSPHigfVGKh31R+7BaZdY+2AeUhCJ5IA/Kg+9aZSPZdh8kH5kJbWLEoDFz9pxj/v9d8ymzv7rde8//3PO75+v+NeAH8fHxUVar9bXD4Xhps9nSWaTRaO5omGi9Fhoa+u3y8vInPAURERFJOp3OSMYstEVfQ6vVrgcFBb31ZkvjSRgcHNxAt/5MSz2RQFZWFpSVlUFOTg7o9Xqw2+2wt7cHKysrMDc3Bzc3N3KOvJq5vb19R8tD8AW61QflhgUFBbi6uooUKvQGi8WCRqMRyRPFs72wsLDnvjje03CwcltbG15fX+NjsbW1hQaDQYjI+18xMTF6N+shISFvnArY0dGBT8HBwQFmZGQIEeVzKj8/P1glKCwsjKZpnz82NzdjINje3kbyQogot80qCSWMN5iamopnZ2cYKDo7O5WwmcmbcCGhpK2xsL+//4Hy+fk59vX1YVNTE7a2tkoRKDg+Psbx8XGcnZ0VvaGhIZycnJRvFxcXGBsbK0Th4eE1EBcXl0KbO9qIsgJOJHsGLj3R0tKCVMK4uLgo+aNmxbS0NPlWXl6unq+vrxcZOfCVQ1XNFVVaWqoqUAdLpbCRmpoaHBkZwa6uLjHIBwcHB1US3nMOGhsbsbe3V7UxMDCgkHzXUQ/wU6HJzMxUczQ9PQ37+/uQl5cHU1NT3Dsi56YcGxuDk5MTSE9PFxk368zMDBQXFz+o1tzcXPlGfAYduS6JoduoChsbGzKTFyoBo7KyUgZjaWkJlHNFRUXgisTERDnL9mnW2lh4dXWlKvCzwfiXwBuoH/zqMImZZtzZ2VGF2dnZMi8sLACFU5XPz89DXV0dULOqMgqHXxKgUjPw5bnklGeEeyUpKUkS19DQgGQch4eHMSUlRZLd09ODFC5ZU3VKtbnCZDIp75mESEud+YMNjo6OqkrLy8uYkJDgVsK1tbViVCHhivNHonHGrJXCYkxOTobd3V0ua/Hy8PBQqml9fR2io6OlEKqrqyVXR0dHMDExwf8dIG/d8mc2m4H6h/NrFUFUVFQcTb/5pu3t7fg/4BouAQma4L55kG6PgcIjCUFDufkC9880dnd3YyDwRiJERPBJSXJVVRVubm7iU+CWeA/gP+RHjiJv6DcsnV5SUiL/eF9Nis6+OT09hYqKir+J94TIyMgX5NU0Le3gUsZcuo8ZTn2vnqigcs6g8q6iG76i8YyGnobiyiPaHax/AKbQPd13/ocwAAAAAElFTkSuQmCC';

export const C2PA_INVALID_ICON = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAEn0lEQVR4AaVVa0hcRxQ+9+66u3bXx6pgVLBWu5KuxkctPsCmUaFF+0MKShtLDaEgKvlRCrYmadNtGpJG/0mFgoSC1SJFBKGBKGp8oCU+a32kbWS3JaKVgBqzmmp27/SbiV523dWa5sBl5p6ZOd95fHNGQ4dIYWGhfnFx8XVJkopkWX4zICAgHXNTVlbW39C76HkkJCQkQafT/YDpGj62/wPglkajadfr9Yn0rGKz2XBevoQp95LFxsayqqoq1tTUxDo6OlhzczOrqKhgiYmJnoBf83NHAigtLdUgHTf4wZiYGNba2soURWEHSXt7O4uPjxdAiOpmWFhY8H+CaLXaen4gIyODLS8vs6PI+vo6Ky4uFkBIbytG6UAA5LYIg5KQkMBWV1fZs8jOzg7Lzs4WQAaD4f2DMGQwZhwfm52dZf9H7HY7MxqNDDYckZGRxv0AGqSpALn/tKysjCorK9WF8fFxamxspL6+PgoNDaXo6Gih7+/vp8nJSYqKiqK2tjZyu91ktVrJ6XTS0NBQqMvl+hm6P7xQkMvLPIre3l7Vs9raWhE+19Mui7iOS15eHs+/YB7X19XVCf3w8PAeCb7zyRUM3cICW1lZEZvhudicmprKJiYm2PT0NEtKShKAIyMjAoSvp6ens5aWFuZwONTamM1mhsz8Rn5YNcMXEaLYXF1dLQwODAyokXFDPT09gnX5+flinTuwX1JSUvi9WfPBQD144VUFDIkRd0DVxcXFiW83coIhAhN9HA4MDCRg+VxMGQj3NzY2CNQVCovFIsaZmRl109jYGF04f57gPcEpOkwAQv7SZeNr3d3dIuTR0VEeMoPnopWAQaLIXDc3N8cKkC5ew/W1NZ90ZWVmcoSHPiC4iG9xkPLycnVzfX29MES7zEK7YQ0NDWJtD2QNILztKKil+BS3AEHiH/Jehq1qDfhExqE7GF+bAv9PpKSIBV4b0JK2traoqKiIIiIihN5ht9Mm7kTEfTvd+7wGfUI5OHOS/MEbvyy08iIpALkCdinvnT5N6EdiB79sJSUlhAhVAC4vgRDJcGT7L4cAML2STJKsUdclSVa0puA/+VQjk5XrBBPA8U4AfTs/P09oeLS0tERHEjAt8p1SstiuAUiGVS0dKzszqXsxrpMvK+xpw1TplpaW9hFy//3g4CDl5uaKluGXKd4JIfv1y6QNDgHQdXr5i6tkshy3Pr47e87LF88f/tx2dXV9goJ+ydcATHhqKScnR/QvvpntHjL03aLAgW5xTmMKoowfb7p5ZJOlb8su58ZTu7J87eTUwgW//Z8/q2h0NtTpXc9oPeXsMTOdjTSLueXSVVdAWLhL1huebC8tau59dfEFTxCtPwPb29u8i5bhATuD3pWLep2Abu/lk4DKEgy6AsxPxddcdOvM4crcx1UGeKy3fnPDGV/z2aa9/opRlkTg5BdkT3DDn2C4jahue+o5aU+aTTpU9tSDnzpl5+/zGs40WJTmzn0YFJSc6lXMQ0EOE8lNCwpcf3R31jvlAHv06xR/JBQXI9GRJXoOuZN5PHxjc8eoE+/OY2gCaQdXkP8HmYP/eXVo6gHf9y9a/xBS0kKXtwAAAABJRU5ErkJggg==';

export interface ManifestStats {
	manifestStore: ManifestStore;
	verified: boolean;
	validationResults: ValidationResults;
}
export interface Segment {
	stats: {
		verified: boolean,
		[key: string]: any,
		segmentName: string;
		manifestStore: ManifestStore;
		validationResults?: ValidationResults;
	};
	interval: [number, number];
}

export interface ActiveStats {
	type: SegmentType;
	activeSegmentStats: Segment['stats'] | null;
	overallVerified: boolean;
	errorSegments?: Segment[];
	currentTime?: number;
	lastActiveSegment?: Segment,
	contentVideoShareStopped?: boolean
}

export interface IAssetStats {
	audio?: ActiveStats;
	video?: ActiveStats;
	contentVideo?: ActiveStats;
}

export interface IC2paConfig {
	wasmSrc: string;
	enabled?: boolean;
	viewMoreClickHandler?: () => void;
	trustAnchors?: string | string[];
}
